import React from 'react';
import Slider, { sliderClasses as classesOfSlider } from '@mui/material/Slider';
import { observer } from 'mobx-react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { DiscountStore } from '@gamiphy/loyalty-station-desktop/store/reward/discount';

type Props = {
  min?: number,
  max?: number,
  onChange: (value: number) => void,
  onChangeCommitted?: (value: number) => void,
  value: number | number[],
  percentageRedeem: string,
  disabled?: boolean,
  locked?: boolean
}

const CustomizedSlider: React.FC<Props> = observer(({
  min,
  max,
  onChange,
  onChangeCommitted,
  percentageRedeem,
  value,
  disabled,
  locked,
}) => {
  const { user } = UserStore;
  const marks = React.useMemo(() => DiscountStore.appDiscount?.bundles?.map((bundle) => ({ value: bundle })) ?? [], [DiscountStore.appDiscount?.bundles]);

  return !user ? null : (
    <div
      style={{ width: '100%', position: 'relative' }}
    >
      <Slider
        sx={(theme) => ({
          color: '#909090',
          height: '1rem',
          position: 'relative',
          [`& .${classesOfSlider.thumb}`]: {
            top: '50%',
            margin: 'auto',
            height: '3rem',
            width: '3rem',
            backgroundColor: '#fff',
            zIndex: 10,
            border: `2px solid ${disabled ? '#cfcfcf' : theme.palette.primary.main}`,
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
              boxShadow: 'none',
            },
            '&:after': {
              inset: 0,
            },
          },
          [`& .${classesOfSlider.valueLabel}`]: {
            fontSize: '0.8rem',
            border: 'transparent',
            background: 'transparent',
            '& span': {
              transform: 'none',
              width: '4.1rem',
              color: '#fff',
              textAlign: 'center',
              padding: '2px 0',
              height: '2.22rem',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              background: 'transparent',
              top: '200%',
              '@media (min-height: 600px)': {
                top: '210%',
              },
              '&:after': {
                content: '" "',
                position: 'absolute',
                borderWidth: '16px',
                borderStyle: 'solid',
                display: 'none',
              },
              '& span': {
                color: '#28292c',
              },
            },
          },
          [`& .${classesOfSlider.track}`]: {
            height: '1px',
            borderRadius: 4,
            color: disabled ? '#cfcfcf' : theme.palette.primary.main,
            zIndex: 2,
          },
          [`& .${classesOfSlider.rail}`]: {
            height: '1px',
            borderRadius: 4,
          },
          [`& .${classesOfSlider.mark}`]: {
            display: 'none',
          },
        })}
        aria-label="pretto slider"
        defaultValue={max}
        min={min}
        max={max}
        onChange={(event, v) => onChange(v as number)}
        onChangeCommitted={(event, v) => onChangeCommitted?.(v as number)}
        step={!DiscountStore.appDiscount?.bundles ? 1 : null}
        valueLabelDisplay="on"
        marks={marks}
        valueLabelFormat={percentageRedeem}
        value={value}
        disabled={locked}
      />
    </div>
  );
});

export default CustomizedSlider;
